import { render, staticRenderFns } from "./SampleResults.vue?vue&type=template&id=4a7ef65a&"
import script from "./SampleResults.vue?vue&type=script&lang=js&"
export * from "./SampleResults.vue?vue&type=script&lang=js&"
import style0 from "./SampleResults.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports